import { render, staticRenderFns } from "./AddResourceCostModal.vue?vue&type=template&id=fa2ff20a&scoped=true&"
import script from "./AddResourceCostModal.vue?vue&type=script&lang=js&"
export * from "./AddResourceCostModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceCostModal.vue?vue&type=style&index=0&id=fa2ff20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2ff20a",
  null
  
)

export default component.exports